import { ComponentType } from 'react';

function getDisplayName(WrappedComponent: ComponentType) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export { getDisplayName };
